export const euro = (value) => Number(value || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

export function driverFromCustomer(customer) {
  return {
    first_name: customer.first_name || '', last_name: customer.last_name || '',
    date_of_birth: customer.date_of_birth?.slice(0, 10) || null,
    address: [customer.address, [customer.postal_code, customer.city].filter(Boolean).join(' '), customer.country].filter(Boolean).join(', '),
    driver_license_number: customer.driver_license_number || '',
    driver_license_expiry: customer.driver_license_expiry?.slice(0, 10) || null,
  };
}

const today = () => { const now = new Date(); return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`; };

export function licenseWarnings(booking, referenceDate = today()) {
  if (!booking) return [];
  // Check today and the end of the rental; both must be covered.
  const through = [referenceDate, (booking.end_date || '').slice(0, 10)].sort().pop();
  return [booking.customer || {}, ...(booking.additional_drivers || [])].flatMap((driver, index) => {
    const name = [driver.first_name, driver.last_name].filter(Boolean).join(' ') || (index === 0 ? 'Hauptfahrer' : `Zusatzfahrer ${index}`);
    const problems = [];
    if (!driver.driver_license_number?.trim()) problems.push('Führerscheinnummer fehlt');
    const expiry = (driver.driver_license_expiry || '').slice(0, 10);
    if (!expiry || !/^\d{4}-\d{2}-\d{2}$/.test(expiry) || Number.isNaN(Date.parse(expiry)) || new Date(expiry).toISOString().slice(0, 10) !== expiry) problems.push('Gültigkeitsdatum fehlt oder ist ungültig');
    else if (expiry < referenceDate) problems.push('Führerschein abgelaufen');
    else if (expiry < through) problems.push('Führerschein läuft vor Mietende ab');
    return problems.length ? [{ name, index, problems }] : [];
  });
}

export function photoReadiness(slots, photos) {
  if (slots === null) return { done: false, label: 'Fotokonfiguration noch nicht verfügbar' };
  const required = slots.filter(s => s.active !== false && s.required);
  const missing = required.filter(slot => !(photos || []).some(p => typeof p === 'object' && p?.slot === slot.key && p?.path));
  if (!required.length) return { done: true, label: 'Keine Pflicht-Fotos konfiguriert' };
  return { done: !missing.length, label: missing.length ? `Fehlende Fotos: ${missing.map(s => s.label || s.key).join(', ')}` : `${required.length} Pflicht-Fotos vorhanden` };
}
